// extracted by mini-css-extract-plugin
export var chevron = "_lp-3";
export var chevronRotated = "_lp-4";
export var image = "_lp-1";
export var imageContainer = "_lp-0";
export var shippingAddress = "_lp-2";